import { render, staticRenderFns } from "./demographic-question.vue?vue&type=template&id=0f76bc39&scoped=true&"
import script from "./demographic-question.vue?vue&type=script&lang=js&"
export * from "./demographic-question.vue?vue&type=script&lang=js&"
import style0 from "./demographic-question.vue?vue&type=style&index=0&id=0f76bc39&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76bc39",
  null
  
)

export default component.exports